import Vue from 'vue';
import VueRouter, { NavigationGuard, RouteConfig } from 'vue-router';
import HomeView from '@/views/Home/HomeView.vue';
import { Store } from 'vuex';
import { createAuthGuard } from '@antriver/vue-site-utils/src/util/auth';

Vue.use(VueRouter);

export function createRouter(store: Store<any>): VueRouter {
    const authGuard: NavigationGuard = createAuthGuard(store);

    const routes: Array<RouteConfig> = [
        {
            path: '/',
            name: 'home',
            component: HomeView,
        },
        {
            path: '/about',
            name: 'about',
            component: () => import(/* webpackChunkName: "about" */ '@/views/About/AboutView.vue'),
            meta: {
                headerTitle: 'About',
            },
        },
        {
            path: '/new-place',
            name: 'new-place',
            beforeEnter: authGuard,
            component: () => import(/* webpackChunkName: "new-place" */ '@/views/NewPlace/NewPlaceView.vue'),
            meta: {
                headerTitle: 'Add A Place',
            },
        },
        {
            path: '/new-place/search/:latlon',
            name: 'new-place-search',
            beforeEnter: authGuard,
            component: () => import(/* webpackChunkName: "new-place-search" */ '@/views/NewPlace/NewPlaceSearchView.vue'),
            meta: {
                headerTitle: 'Add A Place',
            },
        },
        {
            path: '/new-place/form',
            name: 'new-place-form',
            beforeEnter: authGuard,
            component: () => import(/* webpackChunkName: "new-place-form" */ '@/views/NewPlace/NewPlaceFormView.vue'),
            meta: {
                headerTitle: 'Add A Place',
            },
        },
        {
            path: '/place/:placeId(\\d+)/:mode?',
            name: 'place',
            component: () => import(/* webpackChunkName: "place" */ '@/views/Place/PlaceView.vue'),
        },
        {
            path: '/near/:latlon',
            name: 'nearby-places',
            component: () => import(/* webpackChunkName: "nearby-places" */ '@/views/NearbyPlaces/NearbyPlacesView.vue'),
        },
        /**
         * Auth
         */
        {
            path: '/login',
            name: 'login',
            props: {
                initialMode: 'login',
            },
            meta: {
                layout: 'wide',
            },
            component: () => import(/* webpackChunkName: "login" */ '@/views/Auth/LoginView.vue'),
        },
        {
            path: '/signup',
            name: 'signup',
            props: {
                initialMode: 'signup',
            },
            meta: {
                layout: 'wide',
            },
            component: () => import(/* webpackChunkName: "login" */ '@/views/Auth/LoginView.vue'),
        },
        {
            path: '/logout',
            meta: {
                layout: 'wide',
            },
            component: () => import(/* webpackChunkName: "logout" */ '@/views/Auth/LogoutView.vue'),
        },
        {
            path: '/forgot',
            name: 'forgot',
            meta: {
                layout: 'wide',
            },
            component: () => import(/* webpackChunkName: "forgot" */ '@/views/Auth/ForgotView.vue'),
        },
        {
            path: '/reset-password',
            name: 'reset-password',
            meta: {
                layout: 'wide',
            },
            component: () => import(/* webpackChunkName: "reset" */ '@/views/Auth/ResetPasswordView.vue'),
        },
        {
            path: '/reactivate',
            meta: {
                layout: 'wide',
            },
            component: () => import(/* webpackChunkName: "reactivate" */ '@/views/Auth/ReactivateView.vue'),
        },
        {
            path: '/verification',
            meta: {
                layout: 'wide',
            },
            component: () => import(/* webpackChunkName: "verification" */ '@/views/Auth/VerificationView.vue'),
        },
        {
            path: '/privacy',
            component: () => import(/* webpackChunkName: "privacy" */ '@/views/Privacy/PrivacyView.vue'),
        },
        {
            path: '/terms',
            component: () => import(/* webpackChunkName: "terms" */ '@/views/Terms/TermsView.vue'),
        },
    ];

    return new VueRouter({
        mode: 'history',
        base: process.env.BASE_URL,
        routes,
        scrollBehavior(to, from, savedPosition) {
            if (savedPosition) {
                return savedPosition;
            }
            return { x: 0, y: 0 };
        },
    });
}
